import { render, staticRenderFns } from "./battery-outline.vue?vue&type=template&id=15b2052d&scoped=true&"
import script from "./battery-outline.vue?vue&type=script&lang=js&"
export * from "./battery-outline.vue?vue&type=script&lang=js&"
import style0 from "./battery-outline.vue?vue&type=style&index=0&id=15b2052d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b2052d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b2052d')) {
      api.createRecord('15b2052d', component.options)
    } else {
      api.reload('15b2052d', component.options)
    }
    module.hot.accept("./battery-outline.vue?vue&type=template&id=15b2052d&scoped=true&", function () {
      api.rerender('15b2052d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/battery-outline.vue"
export default component.exports